<template>
  <div class="homepage">
    <v-style>
      .parallaximage:after {
        background-image: url("https://img.therenees.com/{{headerPhoto.url}}");
      }
      .parallaximage {
        height: 234vw;
        height: {{450*(1-headerPhoto.ratio)}}vw;
      }
      .parallaximage:after {
        height: 208vw;
        height: {{440*(1-headerPhoto.ratio)}}vw;
      }
      .towerphoto .headline {
        top: 33vw;
        top: {{63.4*(1-headerPhoto.ratio)}}vw;
      }
      .towerphoto .towerlink {
        top: 80vw;
        top: {{153.8*(1-headerPhoto.ratio)}}vw;
      }
      .towerphoto .towerlink.story {
        top: 140vw;
        top: {{269.2*(1-headerPhoto.ratio)}}vw;
      }
      .towerphoto .towerlink.contact {
        top: 200vw;
        top: {{384.6*(1-headerPhoto.ratio)}}vw;
      }
      body.home footer {
        bottom: -11vw;
        bottom: {{-60.15*(1-headerPhoto.ratio)}}vw;
      }
    </v-style>

    <div class="towerphoto">
      <div class="headline">
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 674.13 162.33"><title>Hello, it's the Renees</title><path class="cls-1" d="M403.21 83.08v38.77h-40.68V83.08h-25.47v99.8h25.47v-37.1h40.68v37.1h25.59v-99.8ZM473.59 182.88h76.64v-24.69h-51.05v-12.8h42v-23.15h-42v-14.33h51.05V83.08h-76.64ZM592.08 182.88h73.32v-24.69h-47.85V83.08h-25.47ZM704.18 182.88h73.31v-24.69h-47.85V83.08h-25.46ZM809.1 133c0 28.54 24.18 51.82 53 51.82 29.17 0 53-23.28 53-51.82s-23.8-51.81-53-51.81c-28.82-.02-53 23.26-53 51.81Zm25.9 0a27.13 27.13 0 1 1 27.12 27.13A27.05 27.05 0 0 1 835 133Z" transform="translate(-337.06 -81.17)"/><path class="cls-2" d="M705 214.89h5.2v-5.53H705Zm-.28 24.82c0 2.27.94 3.22 3.16 3.22h5.73v-5.06h-1.9a1 1 0 0 1-1-1V222c0-2.22-.94-3.22-3.16-3.22h-5.72v5.11h1.89a.93.93 0 0 1 1 1ZM718.78 234.09c0 8.08 6.67 9.07 10 9.07a11.28 11.28 0 0 0 1.85-.14v-5.25a5.3 5.3 0 0 1-1.09.1c-1.65 0-4.77-.57-4.77-4.54v-9.74h5.48v-4.78h-5.48v-6.57h-5.87v6.57h-3.26v4.78h3.12ZM734.24 219.1h4.07l3.55-10.36h-5.39ZM742.9 239.19a13.2 13.2 0 0 0 10 4.31c5.25 0 9.27-2.84 9.27-7.38 0-8-12.82-7.28-12.82-11.06 0-1.42 1.47-2.18 3.6-2.18 1.32 0 3 .57 3 1.7v1.19h5.3v-2.51c0-3.92-5.2-5-8.46-5-5 0-9.37 2.22-9.37 7 0 7.8 12.72 7.76 12.72 11.16 0 1.61-1.42 2.36-3.26 2.36-4.11 0-7.19-3.54-7.19-3.54ZM780.39 234.09c0 8.08 6.67 9.07 10 9.07a11.22 11.22 0 0 0 1.84-.14v-5.25a5.18 5.18 0 0 1-1.09.1c-1.65 0-4.77-.57-4.77-4.54v-9.74h5.48v-4.78h-5.45v-6.57h-5.86v6.57h-3.27v4.78h3.12ZM797.32 242.93h6v-11.07a11 11 0 0 1 .37-3.12 6.79 6.79 0 0 1 6.53-5c3 0 3.83 2 3.83 4.92v11.06c0 2.27.94 3.22 3.17 3.22H823v-5.06h-1.89a.94.94 0 0 1-1-1v-9.41c0-6.38-3-9.17-8.42-9.17a9.2 9.2 0 0 0-8.27 4.77h-.1a19.25 19.25 0 0 0 .1-2v-8.46c0-2.18-1-3.17-3.22-3.17h-5.72v5.11h1.89a.93.93 0 0 1 1 1ZM825.36 230.87c0 6.86 5 12.63 13 12.63a14.67 14.67 0 0 0 9.69-3.64l-2.51-4.17a10.93 10.93 0 0 1-6.76 2.7 6.93 6.93 0 0 1-7.23-6.48h16.64s.14-1.51.14-2.22c0-6.38-3.78-11.44-10.68-11.44-7.28 0-12.29 5.2-12.29 12.62Zm6.34-3.12a5.78 5.78 0 0 1 5.91-4.87c2.46 0 4.44 2 4.54 4.87ZM866.64 242.93h6v-9.55a14.71 14.71 0 0 1 .52-3.93 6.79 6.79 0 0 1 6.57-5.06 10.22 10.22 0 0 1 1.47.1v-5.91a7.36 7.36 0 0 0-1.09-.1c-3.69 0-6.57 2.75-7.66 6.2h-.09a11.7 11.7 0 0 0 .09-1.52v-1.41c0-2-1.09-2.94-3.21-2.94h-5.49v5.11h1.89a.93.93 0 0 1 1 1ZM882.81 230.87c0 6.86 5 12.63 13 12.63a14.67 14.67 0 0 0 9.69-3.64l-2.5-4.17a11 11 0 0 1-6.77 2.7 6.93 6.93 0 0 1-7.23-6.48h16.6s.15-1.51.15-2.22c0-6.38-3.79-11.44-10.69-11.44-7.23 0-12.25 5.2-12.25 12.62Zm6.34-3.12a5.78 5.78 0 0 1 5.91-4.87c2.46 0 4.44 2 4.54 4.87ZM911.56 242.93h6v-11.07a10.18 10.18 0 0 1 .47-3.21 6.63 6.63 0 0 1 6.48-4.92c3 0 3.78 2 3.78 4.92v11.06c0 2.27 1 3.22 3.22 3.22h5.72v-5.06h-1.93a1 1 0 0 1-1-1v-9.41c0-6.38-3.08-9.17-8.42-9.17a9.27 9.27 0 0 0-8.51 5h-.09a7 7 0 0 0 .09-1v-.71c0-1.7-1-2.7-3.17-2.7h-5.53v5.11h1.89a.93.93 0 0 1 1 1ZM939.56 230.87c0 6.86 5 12.63 13 12.63a14.64 14.64 0 0 0 9.69-3.64l-2.5-4.17a11 11 0 0 1-6.76 2.7 6.94 6.94 0 0 1-7.24-6.48h16.65s.14-1.51.14-2.22c0-6.38-3.78-11.44-10.69-11.44-7.28 0-12.29 5.2-12.29 12.62Zm6.33-3.12a5.78 5.78 0 0 1 5.91-4.87c2.46 0 4.45 2 4.54 4.87ZM965.89 230.87c0 6.86 5 12.63 13 12.63a14.67 14.67 0 0 0 9.69-3.64l-2.5-4.17a11 11 0 0 1-6.77 2.7 6.93 6.93 0 0 1-7.23-6.48h16.64s.15-1.51.15-2.22c0-6.38-3.79-11.44-10.69-11.44-7.27 0-12.29 5.2-12.29 12.62Zm6.34-3.12a5.78 5.78 0 0 1 5.91-4.87c2.46 0 4.44 2 4.54 4.87ZM991.9 239.19a13.22 13.22 0 0 0 10 4.31c5.25 0 9.27-2.84 9.27-7.38 0-8-12.81-7.28-12.81-11.06 0-1.42 1.46-2.18 3.59-2.18 1.33 0 3 .57 3 1.7v1.19h5.29v-2.51c0-3.92-5.2-5-8.46-5-5 0-9.36 2.22-9.36 7 0 7.8 12.72 7.76 12.72 11.16 0 1.61-1.42 2.36-3.27 2.36-4.11 0-7.18-3.54-7.18-3.54Z" transform="translate(-337.06 -81.17)"/></svg>
      </div>
      <router-link class="towerlink properties" :to="'/browse'">See Our Properties</router-link>
      <router-link class="towerlink story" :to="'/about'">Hear Our Story</router-link>
      <router-link class="towerlink contact" :to="'/contact'">Contact Us</router-link>
      <div class="dimmer"></div>
      <div class="parallaximage">
        <!-- <img src="../assets/homephoto.jpg" > -->
       <div class="whitebg"></div>
      </div>
   </div>

  </div>
</template>

<script>
import Autocomplete from './Autocomplete'
export default {
  name: 'Home',
  data () {
    return {
      plCount: Object.keys(this.$root.PLs).length.toLocaleString(),
      showTyper: false,
      searchPlaceholder: 'Search...',
      sitecontent: this.$root.sitecontent
    }
  },
  methods: {
    searchSelect (option) {
      if (option.plcount !== undefined) {
        this.$router.push('/browse/' + option.slug)
        return false
      }
      if (option.reneeid !== undefined) {
        this.$router.push('/location/' + option.reneeid)
        return false
      }
      if (option.plno !== undefined) {
        this.$router.push('/location/' + option.reneeid)
        return false
      }
    },
    advanceCarousel: function (direction) {
      this.$refs.carousel.advancePage(direction)
    }
  },
  computed: {
    headerPhoto () {
      var random = Math.floor(Math.random() * this.sitecontent.homepage.length)
      return this.sitecontent.homepage[random]
    }
  },
  created () {
    document.title = 'The Renees | Apartment Buildings for Film and Television Production'
    document.head.querySelector('meta[name=description]').content = 'Making filming easier, one location at a time. The Renees is a manages over 150 apartment buildings in the Los Angeles area for Film and Television productions.'
  },
  components: {
    Autocomplete
  },
  mounted: function () {
    this.$root.logActivity('Viewing Home Page')
    document.body.classList.add('home')
    document.documentElement.classList.add('home')
  },
  destroyed: function () {
    document.body.classList.remove('home')
    document.documentElement.classList.remove('home')
  }
}
</script>

<style lang="scss">
@import "../styles/_mixins.scss";
html.home {
  overflow: hidden;
}
body.home {
}
body.home .content {
   height: 100vh;
   width: 100vw;
   perspective: 4px;
   -webkit-perspective: 4px;
   overflow-y: auto;
   overflow-x: hidden;
   -webkit-overflow-scrolling: touch;
   position: relative;
   perspective-origin: top;
   background: #2f2e2e;
}
body.home footer {
  position: relative;
  /* bottom: -11vw; */
  /* bottom: -104px; */
  @include bp(most) {
    /* bottom: -150px; */
  }
}
body.home .content, body.home .container, body.home #app {
  transform-style: preserve-3d;
	-webkit-transform-style: preserve-3d;

}
</style>

<style scoped lang="scss">
@import "../styles/_mixins.scss";
.homepage {
  transform-style: preserve-3d;
	-webkit-transform-style: preserve-3d;
  margin-bottom: -90px;
}
.towerphoto {
  	width: 100%;
    /* height: 200vw; */
  	position: relative;
    z-index: 2;
    transform-style: preserve-3d;
  	-webkit-transform-style: preserve-3d;
    @include bp(most) {
      /* height: 80vh; */
    }
    img {
      width: 100%;
      height: auto;
    }
    .headline {
      position: absolute;
      z-index: 20;
      left: 50%;
      width: 80%;
      font-size: 48px;
      transform: translateX(-49%);
      @include bp(most) {
        width: 47%;
        transform: translateX(-43%);
      }
    }
    .towerlink {
      display: block;
      position: absolute;
      z-index: 20;
      left: 0;
      width: 100%;
      background: rgba(255,255,255,.7);
      font-family: $lulo;
      font-weight: 700;
      color: #a363a5;
      text-align: left;
      text-decoration: none;
      box-sizing: border-box;
      font-size: 26px;
      line-height: 26px;
      padding: 14px 18px 9px;
      @include bp(most) {
        font-size: 48px;
        line-height: 48px;
        padding: 30px 35px 20px;
      }
      &.story {
        text-align: right;
      }
      &.contact {
      }
      &:hover {
        background: #FFF;
      }
    }
}
.dimmer {
    background: linear-gradient(180deg, rgba(216,0,255,.45) 35%, rgba(216,0,255,0) 100%);
    position: absolute;
    z-index: 10;
    width: 100%;
    height: 125vh;
    top: -40vh;
    @include bp(most) {
      height: 125vh;
      background: linear-gradient(180deg, rgba(216,0,255,.35) 35%, rgba(216,0,255,0) 100%);
    }
}

.whitebg {
  position: absolute;
  z-index: 0;
  width:100%;
  height: 70vh;
  top: -35vh;
  background: #FFF;
  transform: translateZ(-1px) scale(1.5);
}


span.clear {
  display: block;
  height: 1px;
  clear: both;
}

img.parallax {
  transform: translateZ(-1px) scale(2);
  transform-origin: top center;

}

.parallaximage {
  transform-style: preserve-3d;
	-webkit-transform-style: preserve-3d;
  margin-top: 50px;
  z-index: 3;
  @include bp(most) {
    margin-top: 90px;
  }
}

.cls-1{fill:#fff}
.cls-2{fill:#f4e9b3}

.parallaximage.photo1:after {
	background-image: url("../assets/homephoto-1.jpg");
}
.parallaximage.photo2:after {
	background-image: url("../assets/homephoto-2.jpg");
}
.parallaximage.photo3:after {
	background-image: url("../assets/homephoto-3.jpg");
}
.parallaximage:after {
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	position: absolute;
	top: 0px;
	left: 0px;
	right: 0px;
	bottom: 0px;
	z-index: 1;
	content: "";
  display: block;
	transform: translateZ(-1px) scale(1.25);
	-webkit-transform: translateZ(-1px) scale(1.25);
  transform-origin: top;
  transform-style: preserve-3d;
	-webkit-transform-style: preserve-3d;
}


</style>



// WEBPACK FOOTER //
// Home.vue?789d7fe2